export default __webpack_public_path__ + "static/media/BearPage1.3d77c460.txt";